/*
 * @Author: 付康 fukang@yuouhui.com
 * @Date: 2022-11-02 18:32:36
 * @LastEditors: 付康 fukang@yuouhui.com
 * @LastEditTime: 2022-11-02 18:32:50
 * @FilePath: /wxkn-experience/src/util/cache.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const cache = {
    school: { id: "", name: "" },
    major: { id: "", name: "" },
    college: { id: "", name: "" },
    nation: { id: "", name: "" },
    IMList: [],
    unReadIM: 0,
    unReadSys: 0
}

export default cache


// WEBPACK FOOTER //
// ./src/util/cache.js